import {
  checkIfContainsTargeted,
  checkIfSelectorMatchTargeted,
} from "libs/clickstream/helpers/clickStreamHelpers";
import { useEffect } from "react";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3,
  EnumCellType,
  EnumGeneratedBy,
  EnumLoggingScreenNames,
  EnumUxTypes,
  EnumWidgets,
  TypeLoggingSelector,
} from "../types/loggingTypes";
import {
  DEFAULT_VALUE,
  ISendLoggingEventProps,
  sendLoggingEvent,
} from "../helpers/sendLoggingEvent";
import {
  getLastScreenName,
  viewListingAction,
} from "../helpers/loggingActions";

export default function useClickEventListenerLogging() {
  const selectorsList = new Set<TypeLoggingSelector>([
    "viewMoreBtnSource",
    "homeFacetsSource",
    "megaMenuLogging",
    "moreCategorySource",
    "postListItemSource",
  ]);
  const loggingInfo = (selector) => {
    switch (selector) {
      case "megaMenuLogging":
        const screenName = getLastScreenName();
        return {
          actionNameLvl2: screenName,
          widget: EnumWidgets.HEADER,
          ux_type: EnumUxTypes.LINK,
        };
      case "moreCategorySource":
      case "homeFacetsSource":
        return {
          actionNameLvl2: EnumLoggingScreenNames.HOME,
          widget: EnumWidgets.LISTING_LATEST_BY_CATEGORY,
          ux_type: EnumUxTypes.LINK,
        };
      case "viewMoreBtnSource":
        return {
          actionNameLvl2: EnumLoggingScreenNames.HOME,
          widget: EnumWidgets.LISTING_LATEST_BY_CATEGORY,
          ux_type: EnumUxTypes.BUTTON,
        };

    }
  };

  function sendLoggingBasedOnTarget(e) {
    let target = e.target as HTMLElement;

    const category = target.getAttribute("data-catRepName");
    const subCategory = target.getAttribute("data-subCatRepName");
    const postId = target.getAttribute("data-id");
    for (const loggingSelector of selectorsList) {
      if (
        checkIfSelectorMatchTargeted("class", target, loggingSelector) ||
        checkIfSelectorMatchTargeted("id", target, loggingSelector) ||
        checkIfContainsTargeted(target, loggingSelector)
      ) {
        const result = loggingInfo(loggingSelector);
        if (loggingSelector === "postListItemSource") {
          viewListingAction({
            ux_type: EnumUxTypes.SCREEN,
            currentScreen: EnumLoggingScreenNames.HOME,
            widgetName: EnumWidgets.LISTING_LATEST_BY_CATEGORY,
            listingData: {
              category: category || DEFAULT_VALUE,
              subcategory: subCategory || DEFAULT_VALUE,
              postId: postId,
            },
            cellType: EnumCellType.NA,
          });
        }
        else {
          sendLoggingEvent({
            actionNameLvl1: EnumActionNameLevel1.SEARCH,
            actionNameLvl2: EnumActionNameLevel2.TAXONOMY,
            actionNameLvl3: EnumActionNameLevel3.CLICK,
            currentWidgetName: result?.widget,
            ux_type: result?.ux_type,
            generatedBy: EnumGeneratedBy.USER,
            listingData: {
              category: category || DEFAULT_VALUE,
              subcategory: subCategory || DEFAULT_VALUE,
            },
          } as ISendLoggingEventProps);
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener("click", sendLoggingBasedOnTarget);
    return () =>
      document.removeEventListener("click", sendLoggingBasedOnTarget);
  }, []);
}
